// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchForm_root__Xneac","icon":"SearchForm_icon__VoyTN","input":"SearchForm_input__rUBec"};